/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-tracker
 * Portfolio-tracker
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LeaderboardSymbolDto
 */
export interface LeaderboardSymbolDto {
    /**
     * 
     * @type {string}
     * @memberof LeaderboardSymbolDto
     */
    exchange: string;
    /**
     * 
     * @type {string}
     * @memberof LeaderboardSymbolDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof LeaderboardSymbolDto
     */
    symbol: string;
    /**
     * 
     * @type {string}
     * @memberof LeaderboardSymbolDto
     */
    name: string;
}

export function LeaderboardSymbolDtoFromJSON(json: any): LeaderboardSymbolDto {
    return LeaderboardSymbolDtoFromJSONTyped(json, false);
}

export function LeaderboardSymbolDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): LeaderboardSymbolDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'exchange': json['exchange'],
        'id': json['id'],
        'symbol': json['symbol'],
        'name': json['name'],
    };
}

export function LeaderboardSymbolDtoToJSON(value?: LeaderboardSymbolDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'exchange': value.exchange,
        'id': value.id,
        'symbol': value.symbol,
        'name': value.name,
    };
}

